import React, { useState } from "react";

//========== Import components from MUI Library ============
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import Collapse from "@mui/material/Collapse";
import Stack from "@mui/material/Stack";
import Tooltip from "@mui/material/Tooltip";

import StarBorderOutlinedIcon from "@mui/icons-material/StarBorderOutlined";

const CollapseRow = ({
  option,
  importFrom,
  newItems,
  modifiedItems,
  disableList,
  importBehavior,
  checkedValues,
  handleParentCheck,
  handleChildCheck,
}) => {
  const [open, setOpen] = useState(false);

  //   Fetching total new and modified items
  let totalLength = checkedValues[option.value]["new"]?.length + checkedValues[option.value]["modified"]?.length;

  const itemList = (items, currentState, currentImportBehavior) =>
    items.map(({ text, value, IsDefault }, i) => {
      return (
        <Box key={`${i}_${value}`}>
          <FormControlLabel
            value={value}
            control={
              <Checkbox
                checked={
                  checkedValues[option.value] &&
                  checkedValues[option.value].checked &&
                  checkedValues[option.value][currentState]?.length > 0 &&
                  checkedValues[option.value][currentState]?.includes(value)
                }
              />
            }
            label={
              <Stack direction="row" alignItems="center" gap={1}>
                <Typography sx={{ m: 0, p: 0 }}>{text}</Typography>
                {IsDefault === 1 && (
                  <Tooltip placement="right" title="Default Pipeline" arrow>
                    <StarBorderOutlinedIcon sx={{ fontSize: "22px" }} color="info" />
                  </Tooltip>
                )}
              </Stack>
            }
            onChange={(e) => {
              handleChildCheck(e, option.value, currentState);
            }}
            disabled={importBehavior === currentImportBehavior}
            sx={{
              width: "100%",
              wordBreak: "break-all !important",
            }}
          />
        </Box>
      );
    });

  return (
    <>
      <TableRow key={option.value}>
        <TableCell sx={{ border: "none", padding: 0 }}>
          <FormControlLabel
            value={option.value}
            control={
              <Checkbox
                checked={checkedValues[option.value].checked && !disableList.checkBoxes.includes(option.value)}
                indeterminate={
                  checkedValues[option.value].checked &&
                  totalLength !== 0 &&
                  totalLength !== newItems["count"] + modifiedItems["count"]
                }
              />
            }
            label={option.text}
            disabled={disableList.checkBoxes.includes(option.value)}
            onChange={handleParentCheck}
            sx={{ margin: 0 }}
          />
        </TableCell>
        <TableCell sx={{ border: "none" }} margin="none" padding="none">
          <Typography
            component="a"
            sx={{ color: "#1675e0" }}
            onClick={() => {
              if (option.value === "connections") {
                if (
                  !disableList.subSection.includes("connections") &&
                  newItems["count"] + modifiedItems["count"] !== 0
                ) {
                  setOpen(!open);
                }
              } else if (newItems["count"] + modifiedItems["count"] !== 0) {
                setOpen(!open);
              }
            }}
            disabled={disableList.subSection.includes(option.value)}
          >{`${newItems["count"]} New ${modifiedItems["count"]} Modified`}</Typography>
        </TableCell>
      </TableRow>
      {importFrom === 1 && option.value === "connections" && !disableList.checkBoxes.includes("connections") && (
        <TableRow>
          <TableCell sx={{ p: "0 12px", m: 0, border: "none", fontStyle: "italic", fontSize: "0.9rem" }} colSpan={2}>
            Provide the correct secret key to import the connections.
          </TableCell>
        </TableRow>
      )}
      <TableRow style={{ backgroundColor: "#f5f5f5" }}>
        <TableCell sx={{ border: "none" }} style={{ padding: "0 0 0 20px" }} colSpan={2}>
          <Collapse
            in={open && !disableList.subSection.includes(option.value)}
            sx={{
              maxHeight: "250px",
              overflow: "auto",
            }}
          >
            <Grid
              container
              sx={{
                padding: "10px 0",
              }}
              spacing={3}
            >
              <Grid
                size={{
                  xs: 6,
                  sm: 6,
                  md: 4
                }}>
                <Typography fontWeight="600">New</Typography>
                {itemList(newItems?.data || [], "new", "mergeAll")}
              </Grid>
              <Grid
                size={{
                  xs: 6,
                  sm: 6,
                  md: 4
                }}>
                <Typography fontWeight="600">Modified</Typography>
                {itemList(modifiedItems?.data || [], "modified", "newOnly")}
              </Grid>
            </Grid>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
};

export default React.memo(CollapseRow);
